//capitalize only the first letter of the string.
export const capitalizeFirstLetter = (string: string) => {
    return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
}

//capitalize all words of a string.
export const capitalizeWords = (string: string) => {
    return string ? string.replace(/(?:^|\s)\S/g, (a) => a.toUpperCase()) : '';
};
